/**
 * 商户中心接口
 * @author ytl
 */
import Qs from 'qs';
import axios from 'axios';
import {INTERACE_MERCHANT_CENTER_BASE_URL} from 'src/config/params-local';
import {getLocalStorageItem, setLocalStorageItem} from 'components/api/utils';
import { logging } from 'components/api/interface-hhy';

/**
 * 创建axios实例
 * @return {axios}
 */
export function createHttp() {
  let $httpMerchant = axios.create({
    baseURL: INTERACE_MERCHANT_CENTER_BASE_URL,
    transformRequest: [function (data) {
      data = Qs.stringify(data);
      return data;
    }],
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Cache-Control': 'no-cache'
    },
    timeout: 30000
  });

// 添加一个响应拦截器
  $httpMerchant.interceptors.response.use(res => {
    if (res.data.code && res.data.code === -1) {
      logging({ request: res.config, responseData: res.data });
      let errMsg = {message: res.data.msg || ''};
      return Promise.reject(errMsg);
    }
    return 'body' in res.data ? res.data.body : res.data;
  }, err => {
    let responseData = err.response ? err.response.data : null;
    logging({
      request: err.config,
      responseData,
      err: responseData ? null : err
    });
    let errorInfo = err.response ? err.response.data : err;
    return Promise.reject(errorInfo);
  });
  return $httpMerchant;
}
/**
 * 使用门店编码获取单个/部分门店信息
 * @param branchIdArr 门店编号数组
 */
export function getBranchMapByIdes (branchIdArr) {
  let localBranches = getLocalStorageItem('branches') ? getLocalStorageItem('branches') : {};
  let refresh = false;
  if (localBranches) {
    for (let branchId in branchIdArr) {
      if (!localBranches[branchId]) {
        refresh = true;
        break;
      }
    }
    if (refresh === false) {
      return new Promise(localBranches);
    }
  }
  let url = '/branches/' + branchIdArr.join(',');
  let $httpMerchant = createHttp();
  $httpMerchant.interceptors.response.use(res => {
    for (let rowIndex in res) {
      let row = res[rowIndex];
      let branchId = row.id;
      localBranches[branchId] = row;
    }
    setLocalStorageItem('branches', localBranches, 86400);
    return localBranches;
  });

  return $httpMerchant.get(url);
}
/**
 * 自助点餐接口
 * 获取门店列表，带有图片和经纬度
 */
export function getBranchWithDish(params) {
  let mapType = 'GD'; // 地图类型高德
  let url = '/branches/uid/' + params.uid + '/appid/' + params.appId + '/businessType/' + params.businessType + '/mapType/' + mapType;
  let $httpMerchant = createHttp();
  return $httpMerchant.get(url)
}

/**
 * 获取门店图片
 * @param {String} branchId
 * @return {Promise}
 */
export function getBranchPic (branchId) {
  let url = '/branches/branchStore/branchId/' + branchId;
  return createHttp().get(url);
}

/**
 * 获取门店图片 新
 * @param {String} branchId
 * @return {Promise}
 */
export function getBranchPics (branchId) {
  let url = '/branches/branchStoreInfo/branchId/' + branchId;
  return createHttp().get(url);
}
/**
 * GET /v1/branch/auth/alipay/detail
 * 根据支付宝shop_id获取门店信息
 * @param {string} shopId
 * @return {Promise}
 */
export function getBranchInfoByAliShopId (shopId) {
  let url = '/branch/auth/alipay/detail?shopId=' + shopId,
    $http = createHttp();
  return $http.get(url);
}



// WEBPACK FOOTER //
// ./src/components/api/interface-merchant-center.js